<template>
    <div class="dialogMainContainer">
        <!-- !!!!!!!! Used to test the dialogGroups !!!!!! -->
        <!--<div class="testContainer">
            <select v-model="selected">
                <option v-for="dg in dialogGroups" v-bind:value="dg.key">
                    {{ dg.key }}
                </option>
            </select>
            <span style="cursor:pointer; margin-left:10px; padding:5px; background-color:darkgray;" @click="testGroup(selected)" type="button">Test Group</span>
        </div>-->
        <div class="mainContentDiv">
            <div class="answerContainer" id="dialogDiv">
                <div v-for="comment in comments">
                    <div class="chatRowAva" v-if="comment.isAva">
                        <div class="avaIcon"><img src="../assets/images/chat_avatar_ava_dark.png" /><br />Ava</div>
                        <div class="bubbleAva ava">
                            <!-- BASIC AVA RESPONSE  -->
                            <div v-if="comment.type === 'basic'">
                                
                                <p>{{comment.text}}</p>
                                               
                                <div v-if="comment.buttons">
                                    <div v-for="button in comment.buttons">
                                        <div v-if="button.type === 'openUrl'">
                                            <a @click="navigateTo(button.value)" class="btn">{{button.title}}</a>
                                        </div>
                                        <div v-if="button.type === 'callParent'">
                                            <a @click="callParent(button.value)" class="btn">{{button.title}}</a>
                                        </div>
                                    </div>
                                </div>
                                <div class="bubbleAvaIconsContainer">
                                    <!--<img src="../assets/images/icon_mail.png" />-->
                                    <!--<img src="../assets/images/icon_print.png" />-->
                                </div>
                            </div>
                            <!-- LIST RESPONSE -->
                            <div v-else-if="comment.type === 'list-response'">
                                <div class="headerDiv">
                                    <p>{{comment.text}}</p>
                                </div>
                                <!-- List of answers view -->
                                <ListContainer v-bind:comment="comment"/>
                            </div>
                            <!-- SINGLE ANSWER RESPONSE -->
                            <div v-else-if="comment.type === 'single-answer-response'">
                                <div class="headerDiv">
                                    <p>{{comment.text}}</p>
                                </div>
                                <CardContainer v-bind:answer="comment.answer"/>
                                <Feedback v-bind:data="{answer: comment.answer, isListAnswer: false}"/>
                            </div>
                        </div>
                    </div>
                    <div class="chatRow" v-else>
                        <div class="youIcon"><img class="avatarImg" v-bind:src="avatarUrl" /><br />{{user.name}}</div>
                        <div v-if="comment.text">
                          <div class="bubble me"><p>{{comment.text}}</p></div>
                        </div>
                        <div v-else>
                          <!-- Thumbs Up / Thumbs Down User Feedback -->
                          <div class="bubble me"><img class="userFeedbackImg" v-bind:src="comment.icon"/></div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="questionContainer">
                <input type="text" name="askAvaQuestion" placeholder="Ask Ava..." v-model="askAvaQuestion" v-on:keyup="listenForEnter" />
                <!--<input type="text" name="searchText" v-model="searchText" v-on:keyup="listenForEnter" v-bind:disabled="waitingForAnswer" />-->
                <button @click="askAva()" type="button"></button>
            </div>
        </div>
    </div>
</template>
<script>
import Vue from "vue";
import { mapState, mapActions, mapGetters } from "vuex";
import dialogGroups from "../store/dialogGroups";
import ListContainer from "./ListContainer.vue";
import CardContainer from "./CardContainer.vue";
import Feedback from './Feedback.vue';

export default {
  namespaced: true,
  name: "Dialog",
  components: {
    ListContainer,
    CardContainer,
    Feedback
  },
  data() {
    return {
      selected: "",
      dialogGroups: dialogGroups.getAllDialogGroups()
    };
  },
  computed: {
    ...mapState({
      user: state => state.user
    }),
    ...mapGetters("dialog", {
      comments: "comments"
    }),
    avatarUrl() {
      const avatar = (this.user && this.user.avatar) || "";
      const token = (this.user && this.user.token) || "";
      return `${avatar}`;
    },
    askAvaQuestion: {
      get() {
        return this.$store.state.askAvaQuestion;
      },
      set(value) {
        this.$store.commit("updateAskAvaQuestion", value);
      }
    }
  },
  methods: {
    ...mapActions({
      askAva: "dialog/askAva",
      navigateTo: "navigateTo",
      callParent: "callParent",
      closeAva: "closeAva"
    }),
    listenForEnter: function(e) {
      if (e.keyCode === 13) {
        this.$store.dispatch("dialog/askAva");
      } else {
        // reset timer once a user starts typing a question
        this.$store.dispatch("setIdleTimeOutTimer");
      }
    },
    scrollToEnd() {
      var container = this.$el.querySelector(".dialogDiv");
      container.scrollTop = container.scrollHeight;
    },
    testGroup(key) {
      this.$store.dispatch("selectGroupByKey", key);
    }
  },
  watch: {
    comments: function(val, oldVal) {
      let vm = this;
      let scorllTimeOut = setTimeout(function() {
        var container = vm.$el.querySelector("#dialogDiv");
        container.scrollTop = container.scrollHeight;
      }, 300);
    },
    selected: function(val, oldVal) {
      this.$store.dispatch("selectGroupByKey", val);
    }
  }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

h3 {
  margin: 40px 0 0;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}

.dialogMainContainer {
  float: left;
  width: 680px;
  height: 518px;
}

.mainContentDiv {
  width: 98.5%;
}

.questionContainer {
  width: calc(100% - 30px);
  height: 48px;
  position: relative;
}

.answerContainer {
  width: calc(100% - 30px);
  height: 450px;
  background-color:#3a3c3e;
  padding: 20px 20px 0px 20px;
  overflow: auto;
  position: relative;
}

input {
  background-color: #535456;
  color: #f1f3f7;
  height: 98%;
  width: 90%;
  margin: auto;
  display: block;
  -webkit-box-flex: 1;
  flex: 1;
  border-radius: 0;
  border-style: solid none none none;
  border-top: 1px solid #030303;
  transition: 0.4s cubic-bezier(0.25, 0.8, 0.25, 1);
  transition-property: font-size, padding-top, color;
  font-family: inherit;
  font-size: 12px;
  line-height: 32px;
  padding-right: 11.7%;
  padding-left: 4.5%;
  padding-top: 0px !important;
  padding-bottom: 0px !important;
}

::placeholder {
    color: #f1f3f7;
    opacity: 1; /* Firefox */
    font-size: 12px;
}

:-ms-input-placeholder { /* Internet Explorer 10-11 */
   color: #f1f3f7;
   font-size: 12px;
}

::-ms-input-placeholder { /* Microsoft Edge */
   color: #f1f3f7;
   font-size: 12px;
}

input:focus {
  border-color: rgb(51, 75, 107) !important;
}

/* clear placeholder text on focus */
input:focus::-webkit-input-placeholder { color:transparent; }
input:focus:-moz-placeholder { color:transparent; } /* FF 4-18 */
input:focus::-moz-placeholder { color:transparent; } /* FF 19+ */
input:focus:-ms-input-placeholder { color:transparent; }

button {
  width: 30px;
  height: 30px;
  border-radius: 15px;
  margin: 0;
  position: absolute;
  top: 18%;
  right: -3%;
  -webkit-transition: 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  transition: 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  z-index: 6;
  padding: 0;
  display: inline-block;
  outline: none;
  background: transparent;
  border: none;
  text-align: center;
  line-height: normal;
  vertical-align: top;
  white-space: nowrap;
  cursor: pointer;
  background-image: url('../assets/images/icon_send.png');
}

button:hover {
  background-image: url('../assets/images/icon_send_overlay.png');
}

.chatRowAva {
  min-height: 70px;
  display: inline-block;
  margin-top: 10px;
  width: 100%;
}

.chatRow {
  text-align: right;
  position: relative;
  display: inline-block;
  margin-top: 10px;
  width: 100%;
}

.avatarImg {
  border-radius: 50%;
  border: 4.1px solid #20b90b;
  width: 58px;
  height: 58px;
}

.avaIcon {
  float: left;
  text-align: center;
  font-weight: bold;
  margin-top: 5px;
}

.bubbleAva {
  background-color: #585a5a;
  border: 1px solid #252424;
  border-radius: 10px;
  display: inline-block;
  padding: 10px 12px;
  position: relative;
  vertical-align: top;
  max-width: 400px;
  text-align: left;
}

/* 
  Code by Scott 
  https://stackoverflow.com/questions/9450733/css-triangle-custom-border-color
*/
/* this forms the triangles */
.bubbleAva:after,
.bubbleAva:before {
    content: '';
    display: block;
    position: absolute;
    right: 100%;
    width: 0;
    height: 0;
    border-style: solid;
}


/* this border color controlls the color of the triangle (what looks like the fill of the triangle) */
.bubbleAva:after {
    top: 18px;
    border-color: transparent #585a5a transparent transparent;
    border-width: 7px;
}

/* this border color controlls the outside, thin border */
.bubbleAva:before {
    top: 17px;
    border-color: transparent #252424 transparent transparent;
    border-width: 8px;
}

.ava {
  float: left;
  margin: 5px 20px;
}

.youIcon {
  position: absolute;
  right: 0px;
  text-align: center;
  font-weight: bold;
}

.bubble {
  position: relative;
  top: 1px;
  right: 65px;
  background-color: #2d3f4d;
  border: 1px solid #252424;
  border-radius: 10px;
  display: inline-block;
  padding: 10px 24px;
  vertical-align: top;
  max-width: 360px;
  text-align: left;
}

/* 
  Code by Scott 
  https://stackoverflow.com/questions/9450733/css-triangle-custom-border-color
*/
/* this forms the triangles */
.bubble:after,
.bubble:before {
    content: '';
    display: block;
    position: absolute;
    left: 100%;
    width: 0;
    height: 0;
    border-style: solid;
}


/* this border color controlls the color of the triangle (what looks like the fill of the triangle) */
.bubble:after {
    top: 16px;
    border-color: transparent transparent transparent #2d3f4d;
    border-width: 7px;
}

/* this border color controlls the outside, thin border */
.bubble:before {
    top: 15px;
    border-color: transparent transparent transparent #252424;
    border-width: 8px;
}

.me {
  float: right;
  margin: 5px 20px 15px 20px;
}

.me p {
  max-width: 100%;
  overflow: hidden;
  word-wrap: break-word;
}

.me::before {
  /*box-shadow: 2px -2px 2px 0 rgba( 178, 178, 178, .4 );*/
  right: -7px;
}

.userFeedbackImg {
  display: inline-block;
  width: 40px;
  padding: 8px;
}

.bubbleAvaIconsContainer {
}

.bubbleAvaIconsContainer img {
  float: right;
  padding-right: 10px;
  cursor: pointer;
}

.btn {
  display: inline-block;
  font-weight: 400;
  text-align: center;
  white-space: nowrap;
  vertical-align: middle;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  border: 1px solid transparent;
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  line-height: 1.5;
  border-radius: 10px;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out,
    border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  color: #fff;
  background-color: #195a9a;
  text-decoration: none;
  cursor: pointer;
}

#allowSpeechBtn {
  width: 394px;
  height: 74px;
  margin: 200px auto;
  background-image: url(~/ava/avaspeakbutton-regular.png);
}

#allowSpeechBtn:hover {
  opacity: 0.5;
}

#closeBtnDiv {
  position: relative;
}

#closeBtn {
  position: absolute;
  right: 0px;
  width: 31px;
  height: 31px;
  background-image: url(~/ava/ava_x_reg.png);
  cursor: pointer;
}

#closeBtn:hover {
  background-image: url(~/ava/ava_x_hover.png);
}

.headerDiv {
  margin-bottom: 12px;
}
</style>
